import { GetUser, GetUserToken } from '@auth/auth.types'
import { LoggedUser } from '@professionals/professionals.types'

export const CURRENT_USER_KEY = '@nilohealth/analytics-web/current-user'

export const USER_TOKEN_KEY = `${CURRENT_USER_KEY}/token`

export const getCurrentUser: GetUser = () => {
  try {
    const userText = window.localStorage.getItem(CURRENT_USER_KEY) || ''
    const user = JSON.parse(userText)

    return user as LoggedUser
  } catch (err) {
    return undefined
  }
}

export const getUserToken: GetUserToken = () => {
  try {
    return window.localStorage.getItem(USER_TOKEN_KEY) || ''
  } catch (err) {
    return undefined
  }
}
